import {httpsCallable} from 'firebase/functions';
import {useCallback, useState} from 'react';
import {firebaseFunction} from '../../config/firebase';

export function useGenerateStudy() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const generateStudy = useCallback(
    async (moduleId: string, topic: string, additionalInfo?: string): Promise<string> => {
      setLoading(true);
      setError(undefined);
      try {
        const fn = httpsCallable<{moduleId: string; topic: string; additionalInfo?: string}, string>(
          firebaseFunction,
          'generateStudy',
        );
        const result = await fn({moduleId, topic, additionalInfo: additionalInfo || undefined});
        const content = result.data;
        if (typeof content !== 'string') {
          throw new Error('Invalid response from generateStudy');
        }
        return content;
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    generateStudy,
    loading,
    error,
  };
}
